import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { getHomeRouteForRole } from "@/constants/routes";
import { useAuth } from "@/shared/hooks/useAuth";

const ModuleGuestRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, isHydrated, user } = useAuth();

  if (!isHydrated) {
    return <div style={{ padding: 24 }}>Loading session...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to={getHomeRouteForRole(user?.role)} replace />;
  }

  return children;
};

export default ModuleGuestRoute;
